export default class Flow {
  static _flowInProgress: string = null
  static _flowTimeout: Function = null
}
